import { render, staticRenderFns } from "./BalancerKpi.vue?vue&type=template&id=0cc2c1b6&scoped=true"
import script from "./BalancerKpi.vue?vue&type=script&lang=js"
export * from "./BalancerKpi.vue?vue&type=script&lang=js"
import style0 from "./BalancerKpi.vue?vue&type=style&index=0&id=0cc2c1b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2c1b6",
  null
  
)

export default component.exports